module.exports = ".chart-no-data{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.chart-no-data>i{\n  font-size: xx-large;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stats/charts/table/table.component.css
// module id = ./src/app/modules/stats/charts/table/table.component.css
// module chunks = main